import { Email, Pill } from "../../common/UserPill/UserPillStyles";
import Icon from "../../common/Icon";
import FlashPCBTooltip from "../../common/FlashPCBTooltip";
import React from "react";
import Link from "next/link";
import { useAppSelector } from "../../../utils/hooks/store";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../utils/group";
import UserPill from "../../common/UserPill";
import { DEMO_BOARD_SLUG } from "../../../constants/boards";
import { useProjectOwner } from "../../../utils/hooks/commonly-stored/users";

export default function ProjectOwner({
  boardId,
  userId,
}: {
  boardId: string;
  userId: string | null;
}) {
  const { groups } = useAppSelector((state) => state.auth);
  const projectOwner = useProjectOwner(userId !== null ? boardId : null);

  if (boardId === DEMO_BOARD_SLUG) {
    return null;
  }

  if (userId === null) {
    return (
      <Pill>
        <Icon src={"/icons/person.svg"} alt={"Owner"} iconDimension={16} />
        <Email>Anonymous board</Email>
      </Pill>
    );
  }

  if (projectOwner === null) {
    return null;
  }

  const isAdminOrEngineer =
    groups.includes(ADMIN_GROUP) || groups.includes(ENGINEER_GROUP);

  const content = isAdminOrEngineer ? (
    <Link
      href={`/internal/users/${projectOwner.id}`}
      target={"_blank"}
      style={{ color: "#FFFFFF" }}
    >
      See user details
    </Link>
  ) : (
    <div>{projectOwner.email} made you a collaborator on this project.</div>
  );

  return (
    <FlashPCBTooltip content={content}>
      <UserPill user={projectOwner} />
    </FlashPCBTooltip>
  );
}
